const i = {
  name: "Exclusivity",
  dimensions: { width: 40, height: 40 },
  content: `
   <svg fill="none">
<g clip-path="url(#clip0_3699_13)">
<path d="M20 9C26.0751 9 31 13.9249 31 20C31 26.0751 26.0751 31 20 31C13.9249 31 9 26.0751 9 20C9 13.9249 13.9249 9 20 9ZM20 11C15.0294 11 11 15.0294 11 20C11 24.9706 15.0294 29 20 29C24.9706 29 29 24.9706 29 20C29 15.0294 24.9706 11 20 11Z" fill="currentColor"/>
<path d="M40 40H0V0H40V40ZM2 38H38V2H2V38Z" fill="currentColor"/>
</g>
<defs>
<clipPath id="clip0_3699_13">
<rect width="40" height="40" fill="white"/>
</clipPath>
</defs>
</svg>
    `
};
export {
  i as Exclusivity
};
